import { useState, useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import api from "common/utils/api";
import { useNavigate } from "react-router-dom";
import { showMessageModal } from "common/utils/modalController";

const useLoadingSample = (initialData, delay = 500) => {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setData(initialData);
      setLoading(false);
    }, delay);

    return () => clearTimeout(timeout);
  }, [initialData, delay]);

  return { data, setData, loading, setLoading };
};

const useLoadingData = (url, params, delayTime = 1000) => {
  // 이후 useLoadingSample 말고 이 함수 사용.
  // initialData 대신 fetch 함수를 받아서 fetch 함수를 실행하고, fetch 함수의 결과를 setData로 넘겨주는 방식
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  params = params || {};
  useEffect(() => {
    api
      .get(url, { params })
      .then((res) => {
        setTimeout(() => {
          setData(res.data);
        }, delayTime);
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response.message === "Forbidden" ||
          error.response.status === 403
        ) {
          showMessageModal(error.response.data.message);
        }
      });
  }, [url, delayTime]);
  useLayoutEffect(() => {
    setLoading(data === null);
  }, [data]);
  return [data, setData, loading, setLoading];
};

const DataLoadingLayout = ({ loading, style, children }) => {
  return loading ? (
    <LoadingField style={style}>
      <LoadingCircle />
    </LoadingField>
  ) : (
    children
  );
};

const LoadingField = styled.div`
  width: 100%;
  /* width: auto; */
  height: 100%;
  /* aspect-ratio: 1; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoadingCircle = styled.div`
  width: 30px;
  height: 30px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid var(--Gray);
  border-top: 3px solid var(--MainBlue);
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export { useLoadingSample, useLoadingData, DataLoadingLayout };
